import { render, staticRenderFns } from "./RecommendedProcedures.vue?vue&type=template&id=413fc56f&scoped=true&"
import script from "./RecommendedProcedures.vue?vue&type=script&lang=js&"
export * from "./RecommendedProcedures.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProcedures.vue?vue&type=style&index=0&id=413fc56f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413fc56f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VImg,VSheet,VSkeletonLoader})
